<template>
  <DetailsListEntry v-if="!edit" class="ma-0" :title="element.label" :content="model" />
  <ComboBox
    v-else
    v-model="model"
    :title="element.label"
    :mark="invalid"
    :content-array="contentArray"
    :data-test="`combobox-${element.name}`"
  />
</template>

<script lang="ts">
import { ComboBoxElement, logger } from '@anschuetz-elog/common';
import { cloneDeep } from 'lodash';
import { computed, defineComponent, PropType, toRef } from 'vue';

import ComboBox from '#/components/ComboBox.vue';
import DetailsListEntry from '#/components/DetailsListEntry.vue';

export default defineComponent({
  name: 'FormComboBox',

  components: {
    ComboBox,
    DetailsListEntry,
  },

  props: {
    element: {
      type: Object as PropType<ComboBoxElement>,
      required: true,
    },

    value: {
      type: Object as PropType<Record<string, unknown>>,
      required: true,
    },

    edit: {
      type: Boolean,
    },

    invalid: {
      type: Boolean,
    },
  },

  emits: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    input: (_value: Record<string, unknown>) => true,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    invalid: (_invalid: boolean) => true,
  },

  setup(props, { emit }) {
    const value = toRef(props, 'value');
    const element = toRef(props, 'element');

    const model = computed<string | undefined>({
      get() {
        const v = value.value[element.value.name];
        if (v !== undefined && typeof v !== 'string') {
          logger.error(
            'Value does not fit to combobox element',
            'value:',
            cloneDeep(v),
            'element:',
            cloneDeep(element.value),
          );
          return undefined;
        }
        return v;
      },
      set(newElementValue) {
        emit('input', { ...value.value, [element.value.name]: newElementValue });
      },
    });

    const contentArray = computed<string[]>(() => (element.value.items || []).map(({ value }) => value));

    return { model, contentArray };
  },
});
</script>
